export default "__VITE_ASSET__Du7BUN_5__"